import api from '../lib/api';
import type { Integration, IntegrationFilterOptions, IntegrationResponse } from '../types/integration';

class IntegrationService {
  async getIntegrations(filters: IntegrationFilterOptions = {}): Promise<IntegrationResponse> {
    const response = await api.get('/integrations', { params: filters });
    return response.data;
  }

  async getIntegration(id: number): Promise<Integration> {
    const response = await api.get(`/integrations/${id}`);
    return response.data;
  }

  async createIntegration(data: Partial<Integration>): Promise<Integration> {
    const response = await api.post('/integrations', data);
    return response.data;
  }

  async updateIntegration(id: number, data: Partial<Integration>): Promise<Integration> {
    const response = await api.put(`/integrations/${id}`, data);
    return response.data;
  }

  async deleteIntegration(id: number): Promise<void> {
    await api.delete(`/integrations/${id}`);
  }

  async validateIntegration(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/integrations/${id}/validate`);
    return response.data;
  }
}

export default new IntegrationService();
